const BACKEND = {

  LOCAL: "http://localhost:4321",
  PROD: "https://api.database-design.ru",

}

const HOST = BACKEND.PROD;

export {

  HOST

}
